module.exports = __webpack_public_path__ + "static/media/carousel.89e6b802.webp";